import { render, staticRenderFns } from "./TeaserBig.vue?vue&type=template&id=a539df40&"
import script from "./TeaserBig.vue?vue&type=script&lang=js&"
export * from "./TeaserBig.vue?vue&type=script&lang=js&"
import style0 from "./TeaserBig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports